document.addEventListener('alpine:init', () => {
  Alpine.data('sortableTable', (data) => ({
    data: data,
    sortKey: null,
    sortDirection: 'asc',
    sort(key) {
      console.log(key)
      if (this.sortKey === key) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortDirection = 'asc'
      }
    },
    sortedData() {
      if (!this.sortKey) return this.data
      return this.data.slice().sort((a, b) => {
        const aValue = a[this.sortKey]
        const bValue = b[this.sortKey]
        if (this.sortDirection === 'desc') {
          return aValue.localeCompare(bValue)
        } else {
          return bValue.localeCompare(aValue)
        }
      })
    },
  }))
})
